import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { history } from "../../../history/history";

import SideBar from "../common/sideBar";

import { axiosInstnace as Axios } from "../../../util/util";
import { endPoints } from "../../../config";
import Pagination from "../common/Pagination";
import NoData from "../common/NoData";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import TrackCoupon from "./trackcoupon";
import Autocomplete from "../../common/Autocomplete.jsx";

const Coupon = (props) => {
  //Set initial state
  const [typeText, handleTypeText] = useState("Amount in Percentage");
  const [coupons, handleCoupons] = useState([]);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const [startDate, handleStartDate] = useState(null);
  const [classPercentage, handleClassPercentage] = useState("");
  const [frequency, handleFrequency] = useState("onetime");
  const [customer, handleCustomer] = useState("");
  const [advertisers, handleadvertisers] = useState([]);
  const [customerSpecific, handleCustomerSpecific] = useState(false);
  const [classAmount, handleClassAmount] = useState("none");
  const [amount, handleAmount] = useState(undefined);
  const [showcampaigns, handleshowcampaigns] = useState(false);
  const [couponCode, handleCouponCode] = useState(null);
  const includeExpired = useRef(undefined);
  const headinlineBlock = {
    marginRight: "5%",
    display: "inline-block",
  };
  const cusrsorstyle = {
    cursor: "pointer",
  };
  const inlineBlock = {
    marginRight: "5%",
  };
  const adminData = JSON.parse(localStorage.getItem("adminInfo"));
  useEffect(() => {
    getCoupons(0);
    var coupon1 = document.getElementById("coupon1");
    coupon1.checked = true;
  }, []);

  //Get coupons list
  const getCoupons = async (skip) => {
    if (skip) {
      handleSkip(skip);
    }
    debugger
    try {
      const data = await Axios.get(endPoints.getCoupons, {
        params: {
          skip,
          includeExpired: includeExpired.current.checked,
        },
      });
      const result = data.data.data.data;
      if (result) {
        handleCoupons(result);
        handleCount(data.data.data.count);
      }
      let users = await Axios.get(endPoints.getSpecificRoleUsers, {
        params: {
          role: "user",
        },
      });
      users = users.data.data.map((e) => {
        return e.email;
      });
      handleadvertisers(users);
    } catch (error) {
      console.log(error);
    }
  };

  const getCampaigns = (e) => {
    handleCouponCode(e.target.id);
    handleshowcampaigns(true);
  };

  //Handle Amount value
  const handleValue = (e) => {
    let amount = e.target.value;
    if (
      classPercentage === "" &&
      Number(amount) <= 100 &&
      Number(amount) >= 0
    ) {
      handleAmount(amount);
    } else if (
      classAmount === "" &&
      Number(amount) >= 0 &&
      Number(amount) <= 20000
    ) {
      handleAmount(amount);
    } else if (classPercentage === "" && Number(amount) === NaN) {
      handleAmount("");
    } else if (
      (classAmount === "" && Number(amount) === NaN) ||
      amount === ""
    ) {
      handleAmount("");
    } else {
      handleAmount("");
    }
  };

  //Generate a coupon
  const createCoupon = async () => {
    if (
      amount === "" ||
      startDate === null ||
      (!frequency && !toast.isActive("1"))
    ) {
      toast.error("All Fields Are Mandatory", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    } else if (amount === "0" && !toast.isActive("1")) {
      toast.error("amount must be greater than 0", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    if (amount === "" || amount === "0") {
      return;
    }
    let type = "";
    if (classPercentage.length === 0) {
      type = "percentage";
    } else {
      type = "Flat Rate";
    }
    if (customerSpecific && !customer) {
      toast.error("Please provide a valid customer email", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }

    const params = {
      type,
      discount: Number(amount),
      validUntil: startDate.valueOf(),
      userEmail: adminData.email,
      frequency,
      customer,
    };
    try {
      const data = await Axios.post(endPoints.createCoupons, params);
      const result = data.data;
      if (result.statusCode === 200) {
        handleStartDate(null);
        handleAmount("");
        getCoupons(0);
      } else {
        toast.error("something went wrong", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "2",
        });
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (date) => {
    handleStartDate(date);
  };
  //Return coupon table
  return (
    <div className="dashboardContainer">
      <HeaderAdminpanel />
      {!showcampaigns && (
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>

          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">Coupon Management</div>
            </div>
            <div className="create_coupon">
              <h3>Create Coupon</h3>
              <div className="coupon_type">
                <div style={{ display: "inline-block" }}>
                  <span className="coupon_head">Coupon Type</span>
                  <div className="radio_coupon">
                    <p className="percentage_container">
                      <input
                        type="radio"
                        id="coupon1"
                        name="radio_coupon"
                        className="custm_radio"
                        onClick={() => {
                          handleClassAmount("none");
                          handleClassPercentage("");
                          handleAmount("");
                          handleTypeText("Amount in Percentage");
                        }}
                      />
                      <label for="coupon1">In Percentage</label>
                    </p>
                    <p>
                      <input
                        type="radio"
                        id="coupon2"
                        name="radio_coupon"
                        className="custm_radio"
                        onClick={() => {
                          handleClassPercentage("none");
                          handleClassAmount("");
                          handleAmount("");
                          handleTypeText("Amount in Flat Rate");
                        }}
                      />
                      <label for="coupon2">Flat Rate</label>
                    </p>
                  </div>
                </div>
                <div style={{ display: "inline-block", marginLeft: "100px" }}>
                  {" "}
                  <span className="coupon_head">Coupon Frequency</span>
                  <div className="radio_coupon">
                    <p className="percentage_container">
                      <input
                        type="radio"
                        id="onetime"
                        className="custm_radio"
                        checked={frequency === "onetime"}
                        onClick={(e) => {
                          handleFrequency(e.target.id);
                        }}
                      />
                      <label for="onetime">One Time</label>
                    </p>
                    <p>
                      <input
                        type="radio"
                        id="multi"
                        className="custm_radio"
                        checked={frequency === "multi"}
                        onClick={(e) => {
                          handleFrequency(e.target.id);
                        }}
                      />
                      <label for="multi">Multiple</label>
                    </p>
                  </div>
                </div>
                <div style={{ display: "inline-block", marginLeft: "100px" }}>
                  {" "}
                  <span className="coupon_head">Target Audience</span>
                  <div className="radio_coupon">
                    <p className="percentage_container">
                      <input
                        type="radio"
                        id="general"
                        className="custm_radio"
                        checked={!customerSpecific}
                        onClick={(e) => {
                          handleCustomerSpecific(false);
                        }}
                      />
                      <label for="general">General</label>
                    </p>
                    <p>
                      <input
                        type="radio"
                        id="customer"
                        className="custm_radio"
                        checked={customerSpecific}
                        onClick={(e) => {
                          handleCustomerSpecific(true);
                        }}
                      />
                      <label for="customer">Customer Specific</label>
                    </p>
                  </div>
                </div>
              </div>
              <div className="amount_date">
                <div className="amount_percent">
                  <span className="amount_date_head">{typeText}</span>
                  <span className={`coupon_rupee_sign ${classAmount}`}>
                    <img src="../../../assets/images/rupee-indian.svg" />
                  </span>
                  <input
                    type="text"
                    value={amount}
                    className="percent_input"
                    onChange={handleValue}
                    placeholder="Amount"
                  />
                  <span className={`percentage_sign ${classPercentage}`}>
                    <img src="../../../assets/images/percent.svg" />
                  </span>
                </div>
                <div className="expiry_date">
                  <span className="amount_date_head">Expiry Date</span>
                  <div className="date_container">
                    <DatePicker
                      selected={startDate}
                      onChange={handleChange.bind(this)}
                      minDate={new Date()}
                      placeholderText="Date"
                    />
                    <span className="cla_icon">
                      <img src="../../../assets/images/calendar.svg" />
                    </span>
                  </div>
                </div>
                {customerSpecific && (
                  <div style={{ display: "inline-block", marginLeft: "100px" }}>
                    {" "}
                    <span className="coupon_head">Customer</span>
                    <Autocomplete
                      suggestions={advertisers}
                      addCustomer={handleCustomer}
                      message={"Please select a valid advertiser Email"}
                    />
                  </div>
                )}
              </div>
              <div className="generate_coupon">
                <button onClick={createCoupon}>Generate Coupon</button>
              </div>
            </div>
            <div>
              <h3 style={headinlineBlock} className="create_head">
                Created Coupons
              </h3>
              <span style={inlineBlock}>
                <input
                  type="checkbox"
                  ref={includeExpired}
                  onClick={() => {
                    return getCoupons(0);
                  }}
                />{" "}
                Include Expired Coupons
              </span>
            </div>
            <div className="dashboard-content userListing-dashboard bg-white table-responsive">
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Coupon Code</th>
                    <th>Coupon Expire On</th>
                    <th>Coupon Type</th>
                    <th>Coupon Frequency</th>
                    <th>Customer</th>
                    <th>Discount</th>
                    <th>Applied Campaigns</th>
                    <th>Created By</th>
                  </tr>
                </thead>
                <tbody>
                  {coupons.map((c, i) => (
                    <tr>
                      <td>{skip + i + 1}</td>
                      <td>{c.couponCode}</td>
                      <td>{new Date(c.validUntil).toDateString()}</td>
                      <td>{c.type}</td>
                      <td>
                        {c.frequency === "onetime" ? "One Time" : "Multiple"}
                      </td>

                      <td>{c.customer === "all" ? "All" : c.customer}</td>
                      <td>{c.discount}</td>
                      <td
                        onClick={getCampaigns}
                        id={c.couponCode}
                        style={cusrsorstyle}
                      >
                        {c.campaigns && c.campaigns.length}
                      </td>
                      <td>{c.userEmail}</td>
                    </tr>
                  ))}
                  {coupons.length === 0 && (
                    <tr>
                      <td></td>
                      <td></td>
                      <td className="coupon_nodata"> No Data</td>
                      <td></td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="paginationTable">
                {(skip > 0 || count > 10) && (
                  <Pagination getAllData={getCoupons} totalRecords={count} />
                )}
              </div>
            </div>
          </section>
        </div>
      )}
      {showcampaigns && <TrackCoupon couponCode={couponCode} />}
      {/* <Index/> */}
      <ToastContainer />
      {/* {contact.length ===0 ?
              <NoData /> : null} */}
    </div>
  );
};

export default connect(null, {})(Coupon);



// WEBPACK FOOTER //
// ./web/components/admin/manageCoupon/index.js